import Vue from 'vue';
import Vuex from 'vuex';
import Api from '@/services/api';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loading: false,
    navigationLoading: false,
    accessToken: localStorage.getItem('access-token') || '',
    userTitle: localStorage.getItem('user-title') || '',
    companyTitle: localStorage.getItem('company-title') || '',
    balance: localStorage.getItem('balance') || 0
  },
  mutations: {
    setCurrentUser(state, data) {
      state.accessToken = data.accessToken;
      state.userTitle = data.userTitle;
      state.companyTitle = data.companyTitle;
    },
    logout(state) {
      state.accessToken = '';
      state.userTitle = '';
      state.companyTitle = '';
      state.balance = 0;
    },
    showLoading(state) {
      state.loading = true;
    },
    hideLoading(state) {
      state.loading = false;
    },
    showNavigationLoading(state) {
      state.navigationLoading = true;
    },
    hideNavigationLoading(state) {
      state.navigationLoading = false;
    },
    setBalance(state, balance) {
      state.balance = balance;
    }
  },
  actions: {
    async login(context, { email, password, captchaKey, captchaCode }) {
      await new Promise((resolve, reject) => {
        Api.login(email, password, captchaKey, captchaCode)
          .then(async (response: any) => {
            if (response) {
              localStorage.setItem('access-token', response.data.accessToken);
              localStorage.setItem('user-title', response.data.userTitle);
              localStorage.setItem('company-title', response.data.companyTitle);

              context.commit('setCurrentUser', {
                accessToken: response.data.accessToken,
                userTitle: response.data.userTitle,
                companyTitle: response.data.companyTitle
              });

              resolve(response);
            }
          })
          .catch((error: any) => reject(error));
      });
      await Api.getWalletBalance().then((response: any) => {
        localStorage.setItem('balance', response.data);
        context.commit('setBalance', response.data);
      });
    },
    async logout(context) {
      await Api.logout();
      localStorage.removeItem('access-token');
      localStorage.removeItem('user-title');
      localStorage.removeItem('company-title');
      localStorage.removeItem('balance');
      context.commit('logout');
    },
    showLoading(context) {
      context.commit('showLoading');
    },
    hideLoading(context) {
      context.commit('hideLoading');
    },
    showNavigationLoading(context) {
      context.commit('showNavigationLoading');
    },
    hideNavigationLoading(context) {
      context.commit('hideNavigationLoading');
    },
    balance(context, balance) {
      localStorage.setItem('balance', balance);
      context.commit('setBalance', balance);
    }
  },
  getters: {
    isLoggedIn: (state) => !!state.accessToken
  }
});
